import React, { useState } from 'react';
import axios from '../../plugins/axios';
import styles from '../Client/ClientMainData/clientMainData.module.css';
import getBirthDateFromIIN from '../../utils/getBirthDateFromIIN';
import { get } from 'react-hook-form';
import editProfile from '../../api/clients/editProfile';
import api from '../../plugins/api';
import { useNavigate, useOutletContext, useParams } from 'react-router-dom';
import checkCrmSidebarNotifications from '../../api/notifications/checkCrmSidebarNotifications';
import getClients from '../../api/clients/getClients';
import formatPhoneNumber from '../../utils/formatPhoneNumber';
import getClientDocuments from '../../api/clients/getClientDocuments';

// components
import ClientCheck from '../../components/ClientCheck/ClientCheck';
import Alert from '../../components/Alert/Alert';
import Loader from '../../components/Loader/Loader';
import NotaryForm from '../../components/NotaryForm/NotaryForm';
import SelectPhoto from '../Client/NewClient/ClientCreate/SelectPhoto/SelectPhoto';
import Checkbox from '../../components/Inputs/Checkbox/Checkbox';

// icons
import phoneIcon from '../../brand/generated/input/phone.svg';
import copyIcon from '../../brand/generated/copy.svg';

import { iin, phone } from '../../constants/mask';
import { textStyles } from '../../constants/textStyles';
import Button from '../../components/Button/Button';
import copyToClipboard from '../../utils/copyToClipboard';
import alert from '../../helpers/alert';
import {
  CLIENT_NOTARIAL_VERIFICATION_APPROVED,
  CLIENT_NOTARIAL_VERIFICATION_OPTIONS,
  CLIENT_NOTARIAL_VERIFICATION_REJECTED,
} from '../../constants';
import { colors } from '../../constants/colors';

const ClientNotary = () => {
  const { id } = useParams();
  const [photo, setPhoto] = useState();
  const [uploadPhoto, setUploadPhoto] = useState();
  const [isDisableSelectPhoto, setDisableSelectPhoto] = useState(true);
  const [mainData, setMainData] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [comment, setComment] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [hasPassedVerification, setPassedVerification] = useState(false);
  const [loading, setLoading] = useState(true);
  const [client, setClient] = useState();

  const init = () => {
    setLoading(true);
    getClients({ id })
      .then((res) => {
        const client = res.data.users[0];
        console.log(client);
        const [day, month, year] = getBirthDateFromIIN(client.iin).split('.');
        const mainData = [
          {
            name: 'surname',
            label: 'Ð¤Ð°Ð¼Ð¸Ð»Ð¸Ñ',
            placeholder: 'Ð¤Ð°Ð¼Ð¸Ð»Ð¸Ñ ÐºÐ»Ð¸ÐµÐ½ÑÐ°',
            defaultValue: client.surname,
          },
          { name: 'name', label: 'ÐÐ¼Ñ', placeholder: 'ÐÐ¼Ñ ÐºÐ»Ð¸ÐµÐ½ÑÐ°', defaultValue: client.name },
          {
            name: 'middlename',
            label: 'ÐÑÑÐµÑÑÐ²Ð¾',
            placeholder: 'ÐÑÑÐµÑÑÐ²Ð¾ (ÐµÑÐ»Ð¸ ÐµÑÑÑ)',
            defaultValue: client.middlename,
          },
          {
            name: 'iin',
            label: 'ÐÐÐ',
            placeholder: '_ _ _ _ _ _ _ _ _ _ _',
            mask: iin,
            defaultValue: client.iin,
            component: (
              <button
                style={{ position: 'absolute', right: '5px', top: '0px' }}
                className="hover-lighten"
                onClick={() => {
                  copyToClipboard(client.iin);
                  alert.success('ÐÐÐ ÑÐºÐ¾Ð¿Ð¸ÑÐ¾Ð²Ð°Ð½ Ð² Ð±ÑÑÐµÑ Ð¾Ð±Ð¼ÐµÐ½Ð°');
                }}
              >
                <img src={copyIcon} alt="icon" />
              </button>
            ),
          },
          {
            name: 'born',
            label: 'ÐÐ°ÑÐ° ÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ñ',
            placeholder: 'Ð´Ð´-Ð¼Ð¼-Ð³Ð³Ð³Ð³',
            defaultValue: new Date(year, month, day).toLocaleDateString(),
          },
          {
            label: 'Ð¯Ð·ÑÐº',
            placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
            name: 'languageId',
            options: [
              { value: 1, label: 'ÐÐ°Ð·Ð°ÒÑÐ°' },
              { value: 2, label: 'Ð ÑÑÑÐºÐ¸Ð¹' },
            ],
            defaultValue: client?.language?.title,
          },
          {
            isCheckbox: true,
            label: client.vip ? 'VIP' : 'ÐÐ¾ÑÑÐµÐ´Ð½Ð¸Ðº',
            defaultValue: true,
          },
        ];

        const contacts = [
          {
            name: 'phoneNumber',
            label: 'ÐÐ¾Ð±Ð¸Ð»ÑÐ½ÑÐ¹ ÑÐµÐ»ÐµÑÐ¾Ð½',
            placeholder: '+7(___) ___-__-__',
            mask: phone,
            defaultValue:
              client.phone[1] === '7'
                ? formatPhoneNumber(client.phone)
                : `+7 ${formatPhoneNumber(client.phone.substring(1))}`,
            icon: phoneIcon,
          },
          {
            name: 'email',
            label: 'E-mail',
            placeholder: 'Ð£ÐºÐ°Ð¶Ð¸ÑÐµ Ð°Ð´ÑÐµÑ ÑÐ»ÐµÐºÑÑÐ¾Ð½Ð½Ð¾Ð¹ Ð¿Ð¾ÑÑÑ ÐºÐ»Ð¸ÐµÐ½ÑÐ°',
            defaultValue: client.email,
          },
        ];
        client.phones.forEach((phoneItem, index) => {
          contacts.push({
            name: `phoneNumber_${index}`,
            label: [
              { value: 1, label: 'ÐÐ¾Ð±Ð¸Ð»ÑÐ½ÑÐ¹ ÑÐµÐ»ÐµÑÐ¾Ð½' },
              { value: 2, label: 'ÐÐ¾Ð¼Ð°ÑÐ½Ð¸Ð¹ ÑÐµÐ»ÐµÑÐ¾Ð½' },
              { value: 3, label: 'ÐÐ¾ÑÐ¿Ð¾ÑÐ°ÑÐ¸Ð²Ð½ÑÐ¹ ÑÐµÐ»ÐµÑÐ¾Ð½' },
            ].filter((item) => item.value === phoneItem.typeId)[0].label,
            defaultValue: `+7 ${formatPhoneNumber(phoneItem.number.substring(1))}`,
          });
        });
        client.addresses.forEach((address, index) => {
          contacts.push({
            name: `addressType_${index}`,
            label: [
              { value: 1, label: 'ÐÐ´ÑÐµÑ ÑÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ð¸' },
              { value: 2, label: 'ÐÐ´ÑÐµÑ Ð¿ÑÐ¾Ð¶Ð¸Ð²Ð°Ð½Ð¸Ñ' },
            ].filter((item) => item.value === address.typeId)[0].label,
            defaultValue: address.address,
          });
        });
        client.socials.forEach((social, index) => {
          contacts.push({
            name: `socialType_${index}`,
            label: [
              { value: 1, label: 'Facebook' },
              { value: 2, label: 'VK' },
              { value: 3, label: 'Instagram' },
              { value: 4, label: 'Telegram' },
            ].filter((item) => item.value === social.typeId)[0].label,
            defaultValue: social.value,
          });
        });

        const comments = [];
        client.comments.forEach((comment) => {
          comments.push({
            name: 'comment',
            placeholder: 'Ð£ÐºÐ°Ð¶Ð¸ÑÐµ Ð»ÑÐ±ÑÐµ Ð·Ð°Ð¼ÐµÑÐºÐ¸ Ð¸Ð»Ð¸ ÐºÐ¾Ð¼Ð¼ÐµÐ½ÑÐ°ÑÐ¸Ð¸ Ð¾ ÐºÐ»Ð¸ÐµÐ½ÑÐµ',
            defaultValue: comment.comment,
          });
        });

        setMainData(mainData);
        setContacts(contacts);
        setComment(comments);
        setPhoto(client.photo);
        setPassedVerification(client.notarial_verification === CLIENT_NOTARIAL_VERIFICATION_APPROVED);
        setClient(client);
      })
      .then(() => {
        getClientDocuments({ userId: id }).then((res) => {
          const docs = res.data?.map((doc) => ({
            label: doc?.typeId,
            component: (
              <a
                href={doc?.url}
                target="_blank"
                rel="noreferrer"
                style={{
                  color: colors.cameo,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  width: '100%',
                }}
              >
                Ð¡ÐºÐ°ÑÐ°ÑÑ
                <svg width="18" height="21" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M8 5.5H10V15.5H8V5.5ZM12 9.5H14V15.5H12V9.5ZM4 11.5H6V15.5H4V11.5ZM12 2.5H2V18.5H16V6.5H12V2.5ZM0 1.492C0 0.944 0.447 0.5 0.999 0.5H13L18 5.5V19.493C18.0009 19.6243 17.976 19.7545 17.9266 19.8762C17.8772 19.9979 17.8043 20.1087 17.7121 20.2022C17.6199 20.2957 17.5101 20.3701 17.3892 20.4212C17.2682 20.4723 17.1383 20.4991 17.007 20.5H0.993C0.730378 20.4982 0.479017 20.3931 0.293218 20.2075C0.107418 20.0219 0.00209465 19.7706 0 19.508V1.492Z"
                    fill="var(--brand-primary)"
                  />
                </svg>
              </a>
            ),
          }));

          setDocuments(docs);
        });
      })
      .finally(() => setLoading(false));
  };

  React.useEffect(() => {
    init();
  }, []);
  const navigate = useNavigate();
  const save = () => {
    setLoading(true);
    editProfile({
      id,
      notarial_verification: hasPassedVerification
        ? CLIENT_NOTARIAL_VERIFICATION_APPROVED
        : CLIENT_NOTARIAL_VERIFICATION_REJECTED,
    })
      .then(() => {
        alert.success('ÐÐ°Ð½Ð½ÑÐµ ÑÑÐ¿ÐµÑÐ½Ð¾ ÑÐ¾ÑÑÐ°Ð½ÐµÐ½Ñ');
        if (hasPassedVerification) {
          checkCrmSidebarNotifications({
            notificationIds: client?.notifications.map((i) => i?.id),
          });
        }
        navigate('/notary/clients');
      })
      .catch((err) => {
        alert.error('ÐÑÐ¾Ð¸Ð·Ð¾ÑÐ»Ð° Ð¾ÑÐ¸Ð±ÐºÐ° Ð¿ÑÐ¸ ÑÐ¾ÑÑÐ°Ð½ÐµÐ½Ð¸Ð¸ Ð´Ð°Ð½Ð½ÑÑ');
      })
      .finally(() => setLoading(false));
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className={styles.wrapper}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <SelectPhoto
                photo={photo}
                setPhoto={setPhoto}
                setUploadPhoto={setUploadPhoto}
                style={{ flex: 1 }}
                disabled={isDisableSelectPhoto}
              />
              <p className={styles.date} style={{ margin: '20px 0' }}>
                ÐÐ»Ð¸ÐµÐ½Ñ Ð·Ð°ÑÐµÐ³Ð¸ÑÑÑÐ¸ÑÐ¾Ð²Ð°Ð½: <span>01.09.2022</span>
              </p>
              <ClientCheck
                list={[
                  {
                    title: 'ÐÐ¾ÑÐ°ÑÐ¸ÑÑ',
                    statusLabel: CLIENT_NOTARIAL_VERIFICATION_OPTIONS?.find(
                      (item) => item?.value === client?.notarial_verification
                    )?.label,
                    color: '#6A6A6A',
                    status:
                      client?.notarial_verification == 1
                        ? 'pending'
                        : client?.notarial_verification == 2
                        ? 'success'
                        : 'reject',
                  },
                ]}
                onRefresh={init}
              />
            </div>
            <div className={styles.forms}>
              <NotaryForm title={'ÐÑÐ½Ð¾Ð²Ð½ÑÐµ Ð´Ð°Ð½Ð½ÑÐµ'} form={mainData} />
              <NotaryForm title={'ÐÐ¾Ð½ÑÐ°ÐºÑÐ½ÑÐµ Ð´Ð°Ð½Ð½ÑÐµ'} form={contacts} />
              <NotaryForm title={'ÐÐ¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµÐ»ÑÐ½Ð°Ñ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ'} form={comment} />
              <NotaryForm title={'ÐÐ¾ÐºÑÐ¼ÐµÐ½ÑÑ'} form={documents} />
              <div style={{ backgroundColor: 'white', padding: '30px 20px' }}>
                <div>
                  <p style={{ ...textStyles.formTitle, marginBottom: '16px' }}>ÐÐ¾ÑÐ°ÑÐ¸Ð°Ð»ÑÐ½Ð°Ñ Ð¿ÑÐ¾Ð²ÐµÑÐºÐ°</p>
                </div>
                <div style={{ display: 'flex', columnGap: '15px' }}>
                  <p>ÐÑÐ¾ÑÐµÐ» Ð¿ÑÐ¾Ð²ÐµÑÐºÑ Ð½Ð° Ð²Ð¾Ð·Ð¼Ð¾Ð¶Ð½Ð¾ÑÑÑ ÑÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ð¾Ð½Ð½ÑÑ Ð´ÐµÐ¹ÑÑÐ²Ð¸Ð¹</p>
                  <Checkbox
                    id={'id' + Math.random().toString(16).slice(2)}
                    value={hasPassedVerification ? true : false}
                    onClick={() => setPassedVerification(true)}
                    label={'ÐÐ°'}
                  />
                  <Checkbox
                    id={'id' + Math.random().toString(16).slice(2)}
                    value={hasPassedVerification ? false : true}
                    onClick={() => setPassedVerification(false)}
                    label={'ÐÐµÑ'}
                  />
                </div>
              </div>
              <Button text={'Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸Ñ'} onClick={save} fill style={{ width: '280px' }} />
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default ClientNotary;
